import type { RefObject } from "react";
import type { Toast } from "primereact/toast";

import {
  resolveExportError,
  EXPORT_EMPTY_MESSAGE,
  EXPORT_EMPTY_SUMMARY,
  EXPORT_SUCCESS_MESSAGE,
  EXPORT_SUCCESS_SUMMARY,
} from "@/modules/export";
import type { UseTableExportOptions } from "@/modules/export";

type ExportFeedback = Pick<UseTableExportOptions, "onSuccess" | "onEmpty" | "onError">;

/** Retorno da exportação em mensagens, iguais nas listagens do Hub (AC3). */
export function createExportFeedback(toast: RefObject<Toast | null>): ExportFeedback {
  return {
    onSuccess: () =>
      toast.current?.show({
        severity: "success",
        summary: EXPORT_SUCCESS_SUMMARY,
        detail: EXPORT_SUCCESS_MESSAGE,
        life: 3000,
        closable: true,
      }),
    onEmpty: () =>
      toast.current?.show({
        severity: "info",
        summary: EXPORT_EMPTY_SUMMARY,
        detail: EXPORT_EMPTY_MESSAGE,
        life: 4000,
        closable: true,
      }),
    onError: (error: unknown) => {
      const { summary, detail } = resolveExportError(error);

      toast.current?.show({ severity: "error", summary, detail, life: 5000, closable: true });
    },
  };
}
